
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetActivatedIec as ObiAisTargetActivatedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-activated-iec.js';
 
 
 

 
 export const ObiAisTargetActivatedIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-activated-iec',
   elementClass: ObiAisTargetActivatedIecElement,
   events: {
     
   }
  });
 
 